{
  "common": {
    "welcome": "Welcome",
    "login": "Login",
    "logout": "Logout",
    "register": "Register",
    "forgotPassword": "Forgot Password",
    "username": "Username",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "inviteCode": "Invite Code",
    "profile": "Profile",
    "companyName": "Voyage International",
    "prevStep": "Previous",
    "nextStep": "Next",
    "submit": "Submit",
    "back": "Back",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "processing": "Processing...",
    "saving": "Saving...",
    "save": "Save",
    "yes": "Yes",
    "no": "No",
    "pageSize": "Page Size",
    "total": "Total",
    "itemsPerPage": "items per page",
    "updateSuccess": "Updated successfully",
    "updateFailed": "Failed to update",
    "copyright": "Copyright © GuiyangVoyage 2024",
    "icp": "Guizhou ICP No.2024041317-1",
    "warning": "Warning",
    "deleteConfirm": "Are you sure you want to delete?",
    "expand": "Show More",
    "collapse": "Show Less",
    "qxz": "Please select ",
    "loading": "loading",
    "searchPlaceholder": "Enter keywords for a query",
    "add": "add",
    "search": "search",
    "reset": "reset",
    "actions": "actions",
    "qsr": "Please enter",
    "del": "Delete",
    "selectDelete": "Please select the data that needs to be deleted",
    "num": "number",
    "error": "Operation failed",
    "copyFailed": "copyFailed",
    "userType": {
      "admin": "admin",
      "normal": "normal",
      "customerService": "customerService",
      "finance": "finance",
      "manager": "manager"
    },
    "noData": "noData"
  },
  "menu": {
    "shipment": "Shipment",
    "orders": "Order History",
    "profile": "Profile",
    "customers": "My Customers",
    "guide": "Platform Guide",
    "addresses": "Address Book",
    "contact": "Contact Us",
    "finance": "Financial Details",
    "quoteHistory": "Quote History",
    "customerDetails": "Customer details",
    "customerList": "Customer list",
    "customersView": "Customer Management",
    "orderDetails": "Order details",
    "login": "login",
    "menu": "Menu Management",
    "role": "Role Management",
    "invoice": "Invoice Management"
  },
  "login": {
    "title": "Voyage International Card Expert",
    "subtitle": "We Provide You The Best Solution",
    "usernamePlaceholder": "User ID*",
    "passwordPlaceholder": "Password*",
    "emailPlaceholder": "Email address*",
    "verificationCodePlaceholder": "Verification code*",
    "sendCode": "Send Code",
    "codeSent": "Verification code sent",
    "sendCodeFailed": "Failed to send code",
    "emailInvalid": "Please enter a valid email address",
    "loginType": {
      "password": "Password Login",
      "email": "Email Login"
    },
    "showPassword": "Show Password",
    "hidePassword": "Hide Password",
    "loginButton": "Login",
    "loggingIn": "Logging in...",
    "failed": "Login failed",
    "networkError": "Network error, please try again later",
    "invalidCredentials": "Invalid username or password",
    "verifyCodePlaceholder": "verification code*",
    "verifyCodeInvalid": "Please enter the correct verification code",
    "verifyCodeTitle": "Please enter the graphic verification code"
  },
  "forgotPassword": {
    "title": "Forgot Password",
    "contact": "Please contact us through:",
    "email": "Email",
    "phone": "Customer Service",
    "workingHours": "Working Hours: Mon-Fri 9:00-18:00"
  },
  "register": {
    "usernamePlaceholder": "Username* ",
    "emailPlaceholder": "Email address*",
    "verificationCodePlaceholder": "Verification code*",
    "passwordPlaceholder": "Password* (8-20 characters, must include uppercase/lowercase/numbers)",
    "confirmPasswordPlaceholder": "Confirm Password* (please re-enter password)",
    "inviteCodePlaceholder": "Invite Code* (please enter invite code)",
    "sendCode": "Send Code",
    "codeSent": "Verification code sent",
    "sendCodeFailed": "Failed to send verification code",
    "emailInvalid": "Please enter a valid email address",
    "submitButton": "Register",
    "registering": "Registering...",
    "success": "Registration successful",
    "failed": "Registration failed",
    "usernameInvalid": "Username must be 4-20 characters and can only contain letters, numbers, underscore and dash",
    "passwordInvalid": "Password must be 8-20 characters and contain at least one uppercase letter, one lowercase letter and one number",
    "passwordMismatch": "The two passwords do not match",
    "networkError": "Network error, please try again later",
    "userPhonePlaceholder": "User 's mobile phone*",
    "userPhoneInvalid": "Please enter the correct mobile phone number"
  },
  "views": {
    "guide": {
      "title": "Platform Guide"
    },
    "quoteHistory": {
      "title": "Quote History",
      "quoteNumber": "Quote Number",
      "createdAt": "Created At",
      "origin": "Origin",
      "destination": "Destination",
      "cargo": "Cargo",
      "service": "Service",
      "price": "Price",
      "noQuotes": "No quotes found",
      "loading": "Loading quotes..."
    },
    "addresses": {
      "title": "Address Book",
      "add": "Add Address",
      "searchPlaceholder": "Search addresses...",
      "form": {
        "companyNamePlaceholder": "Enter company name",
        "streetPlaceholder": "Enter street address",
        "cityPlaceholder": "Enter city",
        "statePlaceholder": "Enter state/province",
        "zipPlaceholder": "Enter ZIP code",
        "zipValidation": "Please enter the correct postal code",
        "countryPlaceholder": "Please enter the country",
        "zipError": "Please enter the correct postal code"
      },
      "list": {
        "title": "Address List",
        "columns": {
          "companyName": "Company Name",
          "street": "Street",
          "city": "City",
          "state": "State",
          "zip": "ZIP",
          "country": "Country",
          "actions": "Actions"
        },
        "searchPlaceholder": "After entering the keywords, press the Enter key to query",
        "selectAddressWarning": "Please select the address"
      },
      "fetchError": "Failed to fetch address list",
      "createSuccess": "Address created successfully",
      "updateSuccess": "Address updated successfully",
      "deleteSuccess": "Address deleted successfully",
      "saveError": "Failed to save address",
      "deleteError": "Failed to delete address",
      "deleteConfirm": "Are you sure you want to delete this address?",
      "noAddresses": "No addresses found",
      "invalidZip": "Invalid ZIP code or service unavailable"
    },
    "contact": {
      "title": "Contact Us",
      "phone": "Phone",
      "hotline": "Recharge Hotline",
      "email": "Email",
      "workingHours": "Working Hours",
      "address": "Address",
      "bankAccount": "Bank Account",
      "onlineSupport": "Online Support",
      "wechat": "WeChat"
    },
    "shipment": {
      "title": "Shipment",
      "step1": "Quote",
      "step2": "Details",
      "getNewQuote": "Get New Quotes",
      "quoteNumber": "Quote Number",
      "originInfo": "Origin Information",
      "destinationInfo": "Destination Information",
      "companyName": "Company Name",
      "companyNamePlaceholder": "Type to search",
      "streetAddress": "Street Address",
      "streetAddressPlaceholder": "Enter street address",
      "city": "City",
      "cityPlaceholder": "Enter city",
      "state": "State",
      "statePlaceholder": "Enter state",
      "zip": "ZIP",
      "zipPlaceholder": "Enter ZIP code",
      "country": "Country",
      "pickupDate": "Pickup Ready Date",
      "pickupTime": "Ready Time",
      "pickupCloseDate": "Pickup Close Date",
      "pickupCloseTime": "Close Time",
      "airportPU": "Airport PU",
      "appointment": "Appointment",
      "cfsPickup": "CFS Pickup",
      "constructionSite": "Construction Site",
      "hazardousMaterial": "Hazardous Material",
      "hospitalPickup": "Hospital Pickup",
      "insidePickup": "Inside Pickup",
      "liftgate": "Liftgate",
      "limitedAccessPickup": "Limited Access Pickup",
      "mineSitePickup": "Mine Site Pickup",
      "notification": "Notification",
      "protectFromFreezing": "Protect from Freezing",
      "residential": "Residential",
      "detailsInfo": "Shipment Details",
      "detailsComingSoon": "Detailed information form is coming soon...",
      "airportDelivery": "Airport DEL",
      "churchDelivery": "Church Delivery",
      "groceryWarehouse": "Grocery Warehouse",
      "limitedAccess": "Limited Access Delivery",
      "overLength12": "Over Length - 12ft but less than 16ft",
      "overLength8": "Over Length - 8ft but less than 12ft",
      "additionalServices": "Additional Services",
      "cfs": "CFS",
      "driverAssist": "Driver Assist",
      "insideDelivery": "Inside Delivery",
      "lumperFee": "Lumper Fee",
      "mineSiteDelivery": "Mine Site Delivery",
      "overLength16": "Over Length - 16ft but less than 20ft",
      "overLength20": "Over Length - 20ft to max",
      "palletJack": "Pallet Jack",
      "residentialAppointment": "Residential - Appointment Forward Air",
      "sortAndSeg": "Sort and Seg",
      "TradeShow": "Trade Show DEL",
      "commodityInfo": "Commodity Information",
      "handlingUnit": "Handling Unit",
      "packageType": "Package Type",
      "palletSizePreset": "Pallet Size",
      "palletSizes": {
        "48x40": "Pallets (48×40)",
        "48x48": "Pallets (48×48)",
        "60x48": "Pallets (60×48)",
        "custom": "Pallets (Custom)"
      },
      "pieces": "Pieces",
      "description": "Description",
      "dimensions": "Dimensions",
      "totalWeight": "Total Weight",
      "estimatedDimensions": "Estimated Dimensions",
      "handlingUnitPlaceholder": "Enter handling unit",
      "descriptionPlaceholder": "Type to search saved products",
      "residentialPickup": "Residential Pickup",
      "residentialDelivery": "Residential Delivery",
      "length": "L",
      "width": "W",
      "height": "H",
      "class": "Class",
      "nmfc": "NMFC",
      "linearFeet": "LF",
      "generateSmartQuote": "Generate Smart Quote",
      "pricingInformation": "Pricing Information",
      "carrier": "Carrier",
      "transitTime": "Est. Transit Time",
      "maxLiability": "Max Liability Coverage",
      "rate": "Rate",
      "fsc": "FSC",
      "accessorials": "Accessorials",
      "total": "Total",
      "quoteSpeed": "Quote Speed",
      "request": "Request",
      "guaranteedOnly": "Less-than-truckload quotation",
      "volumeOnly": "Volume Only",
      "saveQuote": "Save Quote",
      "confirmSave": "Confirm Save",
      "cancelSave": "Cancel Save",
      "saveSuccess": "Quote saved successfully",
      "select": "Select",
      "pickupInfo": "Pickup Information",
      "deliveryInfo": "Delivery Information",
      "orderInfo": "Order Information",
      "selectQuoteFirst": "Please select a quote first",
      "contactName": "Contact Name",
      "phone": "Phone",
      "email": "Email",
      "pickupFacility": "Pickup Facility",
      "deliveryFacility": "Delivery Facility",
      "specialPickupInstructions": "Special Pickup Instructions",
      "specialDeliveryInstructions": "Special Delivery Instructions",
      "specialInstructionsPlaceholder": "Enter any special instructions here...",
      "business": "Business",
      "residence": "Residence",
      "construction": "Construction Site",
      "cityStateZip": "City, State ZIP",
      "selected": "Selected",
      "deliveryDate": "Delivery Estimated Date",
      "deliveryTime": "Delivery Estimated Time",
      "deliveryCloseTime": "Delivery Close Time",
      "customerPO": "Customer PO",
      "shipperReference": "Shipper Reference",
      "loadRelease": "Load Release",
      "file": "File",
      "temperature": "Temperature",
      "trackingReference": "Tracking Reference",
      "seal": "Seal",
      "customReference": "Custom Reference",
      "packageTypes": {
        "AFrame": "A-Frame",
        "Bags": "Bags",
        "Bales": "Bales",
        "Barrel": "Barrel",
        "Basket": "Basket",
        "Batteries": "Batteries",
        "Bins": "Bins",
        "Box": "Box",
        "BreakBulk": "Break Bulk",
        "Bundle": "Bundle",
        "Cans": "Cans",
        "Cart": "Cart",
        "Carton": "Carton",
        "Case": "Case",
        "Chest": "Chest",
        "Container": "Container",
        "Crate": "Crate",
        "Cylinder": "Cylinder",
        "Drum": "Drum",
        "Gallons": "Gallons",
        "Gaylords": "Gaylords",
        "HalfPallets": "Half Pallets",
        "Hopper": "Hopper",
        "Jerricans": "Jerricans",
        "LiftVan": "Lift Van",
        "Loose": "Loose",
        "Package": "Package",
        "Pails": "Pails",
        "Pallet": "Pallet",
        "Piece": "Piece",
        "Racks": "Racks",
        "Reel": "Reel",
        "Roll": "Roll",
        "Skid": "Skid",
        "Stacks": "Stacks",
        "Totes": "Totes",
        "Truckload": "Truckload",
        "Tube": "Tube",
        "Tubs": "Tubs",
        "UBox": "U-Box",
        "Unit": "Unit",
        "Vehicle": "Vehicle",
        "Wheels": "Wheels"
      },
      "pleaseComplete": "Please complete the following fields",
      "submitSuccess": "Shipment submitted successfully",
      "submitError": "Failed to submit shipment",
      "pleaseCompleteForm": "Please complete all required fields",
      "generatingQuote": "Generating Quote...",
      "submittingToCarrier": "Submitting to Carrier...",
      "selectAddress": "Select Address",
      "addressLoadError": "Failed to load address list",
      "type": "Type",
      "warehouse": "Warehouse",
      "confirmSubmit": "Confirm Submit",
      "confirmMessage": "Please confirm the shipping information. After submission, cancellation requires contacting customer service.",
      "insufficientBalance": "Insufficient balance",
      "noQuotes": "No quotes available",
      "units": {
        "imperial": {
          "length": "L (in)",
          "width": "W (in)",
          "height": "H (in)",
          "weight": "Total Weight (lbs)",
          "unit": "in"
        },
        "metric": {
          "length": "L (cm)",
          "width": "W (cm)",
          "height": "H (cm)",
          "weight": "Total Weight (kg)",
          "unit": "cm"
        },
        "switch": "Switch Units"
      },
      "oversizedWarning": "This cargo is oversized and will incur additional charges",
      "addLineItem": "Add Line Item",
      "serviceLevel": "Service Level",
      "clearItemsFirst": "Please delete current line items first",
      "totals": {
        "handlingUnits": "Total Handling Units",
        "pieces": "Total Pieces",
        "weight": "Total Weight",
        "pcf": "Total PCF",
        "lf": "Total LF"
      },
      "availableQuotes": "Available Quotes",
      "lineHaul": "Line Haul",
      "fuelSurcharge": "Fuel Surcharge",
      "totalPrice": "Total Price",
      "poReference": "PO Reference",
      "pleaseSelectQuotes": "Please select at least one quote",
      "quoteError": "Error in obtaining quotation",
      "shipmentType": "Shipment Type",
      "dimensionUnits": "Unit of size",
      "weightUnits": "Unit of weight",
      "createdAt": "createdAt",
      "shipmentTypeText": "Transportation",
      "goodsCount": "Goods",
      "priceQuotes": "  Quotes",
      "viewDetails": "viewDetails",
      "editOrder": "editOrder",
      "goodsInfo": "goodsInfo",
      "priceInfo": "priceInfo",
      "providerCode": "providerCode",
      "hasStackable": "Stackable",
      "hazmatDesc": "Hazard category",
      "hasHazmat": {
        "switch": "Switch dangerous goods"
      },
      "unNumber": "unNumber",
      "packingGroup": "packingGroup",
      "dimensionsDesc": "Length × Width × height",
      "invalidHandlingUnit": "The number of pallets for items cannot be 0",
      "invalidDescription": "The name of the product cannot be empty"
    },
    "orders": {
      "title": "Order History",
      "id": "ID",
      "createdAt": "Created Time",
      "originCompanyName": "Origin Company Name",
      "origin": "Origin",
      "destinationCompanyName": "Destination Company Name",
      "destination": "Destination",
      "carrier": "Carrier",
      "proNumber": "Pro No.",
      "poNumber": "PO No.",
      "shipperReference": "Shipper Reference",
      "status": "Status",
      "amount": "Amount",
      "operations": "Operations",
      "charge": "Charge",
      "refund": "Refund",
      "chargeOrder": "Charge Order",
      "refundOrder": "Refund Order",
      "chargeTip": "Please enter the amount to charge",
      "refundTip": "Please confirm the refund operation",
      "chargeAmount": "Charge Amount",
      "amountPlaceholder": "Enter amount",
      "comment": "Comment",
      "chargeCommentPlaceholder": "Please enter the reason",
      "commentPlaceholder": "Please enter the reason",
      "balanceAdjustSuccess": "The supplementary deduction for the order was successful",
      "balanceAdjustError": "Failed to adjust balance",
      "orderAdjustError": "Failed to adjust order",
      "search": {
        "orderNumber": "Search by order number",
        "status": {
          "all": "All Status",
          "progress": "Progress",
          "complete": "Complete",
          "canceled": "Canceled"
        },
        "startDate": "startDate",
        "endDate": "endDate",
        "to": "to",
        "date": {
          "today": "Last week",
          "month": "Last month",
          "months": "Last 3 months"
        },
        "showType": {
          "all": "Display all orders",
          "onlyMine": "Only display my order"
        },
        "query": "Search for system/customer order number/waybill number/username/address"
      },
      "details": {
        "title": "Order Details",
        "shipmentAlerts": "Shipment Alerts",
        "carrierInfo": "Carrier Info",
        "activity": "Activity",
        "origin": "Origin",
        "destination": "Destination",
        "commodities": "Commodities",
        "pickupDate": "Pickup Date",
        "estimatedDeliveryDate": "Estimated Delivery Date",
        "pickupRequirements": "Pickup Requirements",
        "deliveryRequirements": "Delivery Requirements",
        "shipmentReferences": "Shipment References",
        "pricing": "Pricing",
        "fetchError": "Failed to load order details",
        "activityDate": "Date",
        "activityStatus": "Status",
        "activityUser": "User",
        "carrierLabel": "Carrier",
        "pickupNumberLabel": "Pickup Number",
        "proNumberLabel": "Pro Number",
        "originCompanyNameLabel": "Company Name",
        "originStreetAddressLabel": "Street Address",
        "originContactLabel": "Contact",
        "originPhoneLabel": "Phone Number",
        "originEmailLabel": "Email",
        "destinationCompanyNameLabel": "Company Name",
        "destinationStreetAddressLabel": "Street Address",
        "destinationContactLabel": "Contact",
        "destinationPhoneLabel": "Phone Number",
        "destinationEmailLabel": "Email",
        "commoditiesHandlingUnits": "Handling Units",
        "commoditiesPackaging": "Packaging",
        "commoditiesPieces": "Pieces",
        "commoditiesWeight": "Weight",
        "commoditiesHazmat": "Hazmat",
        "commoditiesDescription": "Description",
        "commoditiesDimensions": "Dimensions",
        "commoditiesMarkings": "Markings",
        "commoditiesNMFC": "NMFC",
        "commoditiesClass": "Class",
        "commoditiesTotal": "Total",
        "customerPO": "Customer PO",
        "shipperReference": "Shipper Reference",
        "serviceLevel": "Service Level",
        "linehaul": "Linehaul",
        "fuelSurcharge": "Fuel Surcharge",
        "accessorials": "Accessorials",
        "total": "Total",
        "billOfLadingLabel": "BILL OF LADING",
        "downloadBol": "Download BOL",
        "loadingDetails": "Loading Order Details...",
        "originCityLabel": "City",
        "destinationCityLabel": "City",
        "originZipCode": "ZIP Code",
        "destinationZipCode": "ZIP Code",
        "poReference": "PO Reference",
        "yes": "Yes",
        "no": "No",
        "linearFoot": "linearFoot",
        "traceDesc": "Description"
      },
      "list": {
        "title": "Order List",
        "copyOrderIdSuccess": "System order number copied",
        "copyCustomerReferenceSuccess": "Customer order number copied"
      },
      "fetchError": "Failed to fetch orders",
      "shipmentId": "Shipment ID",
      "userId": "Created By",
      "orderId": "Order ID",
      "poReference": "PO Reference",
      "systemOrderNumber": "System Order Number",
      "copyOrderIdSuccess": "System order number copied",
      "copyCustomerReferenceSuccess": "Customer order number copied",
      "carrierCode": "carrierCode",
      "providerCode": "providerCode",
      "audit": "audit",
      "edit": "edit",
      "backOrder": "Return",
      "auditStatus": "auditStatus"
    },
    "profile": {
      "title": "Profile",
      "userId": "User ID",
      "balance": "Balance",
      "companyName": "Company Name",
      "contactName": "Contact Name",
      "email": "Email",
      "newEmail": "New Email",
      "phone": "Phone",
      "bank": "Bank",
      "bankAccount": "Bank Account",
      "address": "Address",
      "verificationCode": "Verification Code",
      "invitationCode": "Invitation Code",
      "edit": {
        "change": "Edit",
        "title": "Edit Profile",
        "companyNamePlaceholder": "Enter company name",
        "contactNamePlaceholder": "Enter contact name",
        "emailPlaceholder": "Enter email address",
        "newEmailPlaceholder": "Enter new email address",
        "phonePlaceholder": "Enter phone number",
        "bankPlaceholder": "Enter bank name",
        "bankAccountPlaceholder": "Enter bank account",
        "addressPlaceholder": "Enter company address",
        "verificationCodePlaceholder": "Enter verification code",
        "sendCode": "Send Code",
        "codeSent": "Verification code sent",
        "sendCodeFailed": "Failed to send code",
        "emailInvalid": "Please enter a valid email address",
        "verificationCodeRequired": "Please enter the verification code"
      },
      "transactions": {
        "title": "Transaction History",
        "date": "Date",
        "amount": "Amount",
        "note": "Note",
        "balance": "Balance"
      },
      "changePassword": "Change Password",
      "password": {
        "new": "New Password",
        "confirm": "Confirm Password",
        "newPlaceholder": "Enter new password",
        "confirmPlaceholder": "Confirm new password",
        "required": "Password is required",
        "tooShort": "Password must be at least 8 characters",
        "notMatch": "Passwords do not match",
        "changeSuccess": "Password changed successfully",
        "needEmail": "Please add email first"
      },
      "userHead": "userHead"
    },
    "customers": {
      "inviteTitle": "Invite",
      "title": "My Customers",
      "userGroups": "User Groups",
      "userGroup": "User Group",
      "customers": "Customers",
      "searchPlaceholder": "Search customers...",
      "customerId": "Customer ID",
      "companyName": "Company Name",
      "contactName": "Contact",
      "email": "Email",
      "phone": "Phone",
      "fromUser": "From",
      "status": {
        "status": "Status",
        "active": "Enabled",
        "inactive": "Disabled"
      },
      "bankName": "Bank Name",
      "bankAccount": "Back Account",
      "address": "Address",
      "details": {
        "title": "Customer Details",
        "basicInfo": "Basic Information",
        "adminSettings": "Admin Settings",
        "accountNumber": "Account Number",
        "accountNumberPlaceholder": "Enter account number",
        "currentBalance": "Customer Balance",
        "commission": "Commission",
        "status": "Status",
        "statusActive": "Active",
        "statusInactive": "Inactive",
        "fetchError": "Failed to load customer details",
        "increase": "Increase",
        "decrease": "Decrease",
        "increaseBalance": "Increase Balance",
        "decreaseBalance": "Decrease Balance",
        "increaseBalanceTip": "Please enter the amount you want to increase",
        "decreaseBalanceTip": "Please enter the amount you want to decrease",
        "adjustAmount": "Amount",
        "amountPlaceholder": "Enter amount",
        "note": "Note",
        "notePlaceholder": "Please enter the reason for the adjustment",
        "adjust": "Adjust",
        "adjustCommission": "Adjust Commission",
        "adjustCommissionTip": "Please enter the new commission rate (0-100%)",
        "commissionPlaceholder": "Enter commission rate",
        "viewSubOrders": "Allow viewing sub-account orders?",
        "customerOrderList": {
          "orderList": "Order List",
          "shipmentId": "Shipment ID",
          "status": "Status",
          "freightCost": "Freight Cost",
          "fuelSurcharge": "Fuel Surcharge",
          "accessorialFees": "Accessorial Fees",
          "totalCost": "Total Cost",
          "totalSell": "Total Sell",
          "profit": "Profit",
          "noOrders": "No orders found",
          "statusDelivered": "Delivered",
          "statusInTransit": "In Transit",
          "statusPending": "Pending",
          "statusCancelled": "Cancelled"
        },
        "advancedSettings": "Advanced Settings",
        "enable": "Enable",
        "disable": "Disable",
        "allowViewOrders": "Allow viewing orders",
        "disallowViewOrders": "Disallow viewing orders",
        "balanceAdjust": {
          "title": "Balance Adjustment",
          "increase": "Increase Balance",
          "decrease": "Decrease Balance",
          "amount": "Amount",
          "amountPlaceholder": "Please enter amount",
          "note": "Note",
          "notePlaceholder": "Please enter adjustment reason",
          "success": "Balance adjusted successfully",
          "failed": "Failed to adjust balance"
        },
        "insufficientBalance": "Your balance is insufficient",
        "customerInsufficientBalance": "Customer balance is insufficient",
        "userGroups": "User Groups",
        "userGroup": "User Group",
        "customers": "Customers",
        "updatePassword": {
          "title": "Update User Password",
          "button": "Update Password",
          "password": "New Password",
          "passwordPlaceholder": "Enter new password",
          "confirmPassword": "Confirm Password",
          "confirmPasswordPlaceholder": "Re-enter new password",
          "passwordMismatch": "Passwords do not match",
          "success": "Password updated successfully",
          "failed": "Failed to update password"
        },
        "deleteUser": {
          "title": "Delete User",
          "button": "Delete User",
          "confirmTitle": "Confirm Delete User",
          "confirmMessagePrefix": "Are you sure you want to delete user",
          "confirmMessageSuffix": "? This action cannot be undone.",
          "success": "User deleted successfully",
          "failed": "Failed to delete user"
        }
      },
      "inviteCode": "Invite Code",
      "clickToCopy": "Click to copy invite link",
      "copied": "Copied!",
      "inviteLinkTitle": "Invite Link",
      "copySuccess": "Copied Successfully!",
      "confirm": "Confirm",
      "back": "back",
      "level": "level",
      "userStatus": "User Status",
      "orderCount": "orderCount",
      "createTime": "createTime",
      "subCustomer": "Customer Count",
      "edit": "Modify the customer password",
      "delete": "delete",
      "confirmDelete": "Are you sure to delete this customer?",
      "deleteSuccess": "Deleted successfully",
      "deleteFailed": "Deletion failed"
    },
    "finance": {
      "title": "Financial Details",
      "availableBalance": "Available Balance",
      "search": {
        "orderNumber": "Search by order number",
        "types": {
          "all": "All Types",
          "recharge": "Recharge",
          "deduction": "Deduction",
          "refund": "Refund",
          "extraDebit": "Extra Debit",
          "manualDeduction": "manualDeduction",
          "deduction2": "deduction"
        },
        "dateRange": {
          "to": "to"
        },
        "searchButton": "Search",
        "clearButton": "Clear",
        "exportButton": "Export"
      },
      "table": {
        "serialNumber": "Serial Number",
        "systemOrderNumber": "System Order Number",
        "customerOrderNumber": "Customer Order Number",
        "transactionType": "Transaction Type",
        "direction": "Direction",
        "amount": "Amount",
        "balance": "Balance",
        "createdTime": "Created Time",
        "comments": "Comments",
        "copySuccess": "System order number copied",
        "system": "System",
        "repeatPurchasing": "repeatPurchasing",
        "repeatSelling": "repeatSelling"
      },
      "pagination": {
        "total": "Total",
        "itemsPerPage": "items per page"
      },
      "fetchError": "Failed to obtain data",
      "invoice": "invoice",
      "invoiceNo": "Invoice No",
      "amountDue": "Amount Due",
      "invoiceDate": "Invoice Date",
      "billTime": "Billing Period",
      "dueDate": "Due Date",
      "orderNo": "Order No",
      "customer": "Customer",
      "serialNo": "No",
      "serviceItem": "Service Item & Description",
      "quantity": "Quantity",
      "unitPrice": "Unit Price",
      "amount": "Amount",
      "subtotal": "Subtotal",
      "total": "Total",
      "companyName": "Guiyang Woyaji Information Technology Co., Ltd.",
      "companyAddress": "No.1, 11th Floor, Building F-02, F-03",
      "companyAddress2": "Meidi.Lincheng Times, Changling North Road No.8",
      "buttons": {
        "print": "print",
        "editInvoice": "edit"
      },
      "placeholders": {
        "invoiceNo": "Please enter invoice number",
        "invoiceDate": "Please select invoice date",
        "billTime": "Please enter billing period",
        "dueDate": "Please select due date",
        "invoiceData": "Please obtain the invoice data first"
      },
      "saveConfirm": "Save and print",
      "updataConfirm": "Update and print"
    },
    "list": {
      "emptyText": "No Data",
      "loadingText": "Loading..."
    },
    "menu": {
      "list": {
        "title": "Menu Management",
        "columns": {
          "menuName": "Menu Name",
          "icon": "icon",
          "menuType": "menuType",
          "menuSort": "menuSort",
          "noTagsView": "hidden",
          "createTime": "createTime",
          "actions": {
            "addSubmenu": "Add Menu",
            "editMenu": "edit",
            "del": "delete",
            "bindMenu": "Bind Menu",
            "bindUser": "Bind User",
            "select": "select"
          },
          "menuPath": "menuPath",
          "component": "component",
          "noCache": "noCache"
        }
      },
      "form": {
        "menuName": "Menu Name",
        "menuExtend": "Route Name",
        "menuExtendPlaceholder": "Please enter the route name",
        "component": "component path",
        "componentPlaceholder": "Please enter the component path",
        "menuPathPlaceholder": "Please enter the route path",
        "menuPath": "Menu Path",
        "menuNamePlaceholder": "Please enter the menu name",
        "menuName4": "Button Name",
        "parentIdPlaceholder": "Please select the parent menu",
        "parentId": "Parent",
        "menuType": "Menu Type",
        "externalLink": "Route Redirect",
        "externalLinkplaceholder": "Please enter the default redirect URL",
        "icon": "Menu Icon",
        "iconPlaceholder": "Please select the menu icon",
        "activeMenu": "Active Menu",
        "activeMenuPlaceholder": "Please enter the menu to be activated",
        "menuSort": "sort",
        "menuSortPlaceholder": "The smaller the value, the higher the priority. If left blank, the system will generate it by default.",
        "menuExtend4": "Button Permissions",
        "menuExtend4Placeholder": "Please enter the button permissions",
        "apiUrl": "Interface URL",
        "apiUrlplaceholder": "Please fill in the backend interface URI that the current menu or button needs to access. Separate multiple URIs with English commas.",
        "noTagsView": {
          "0": "no",
          "1": "is"
        }
      },
      "updateSuccess": "Update Success",
      "createSuccess": "Create Success",
      "deleteSuccess": "The menu has been deleted successfully.",
      "deleteError": "The menu has failed to be deleted."
    },
    "role": {
      "list": {
        "columns": {
          "actions": {
            "addSubmenu": "Add Role"
          },
          "roleStatus": {
            "0": "Disabled",
            "1": "Enabled",
            "label": "roleStatus"
          }
        }
      },
      "form": {
        "menuType": "menuType",
        "roleName": "roleName",
        "roleNamePlaceholder": "Please enter the role name",
        "roleDesc": "roleDesc",
        "roleDescPlaceholder": "Please enter the role description"
      },
      "bindUser": {
        "userName": "userName",
        "userEmail": "userEmail",
        "userPhone": "userPhone",
        "success": "success",
        "error": "error"
      }
    },
    "order": {
      "form": {
        "auditDesc": "auditDesc",
        "auditDescPlaceholder": "Please enter the review description",
        "repeatPurchasing": "repeatPurchasing",
        "repeatPurchasingPlaceholder": "Please enter the purchase price for the return order",
        "repeatSelling": "repeatSelling",
        "repeatSellingPlaceholder": "Please enter the selling price for the return order",
        "totalOrderProfit": "totalOrderProfit",
        " purchasePrice": "purchasePrice",
        "sellingPrice": "sellingPrice",
        "repeatSelling2": "ROA"
      },
      "auditSuccess": "Successful review",
      "btns": {
        "1": "Approved",
        "2": "Reject"
      },
      "auditError": "Review failed",
      "backOrderSuccess": "Repeat order successful",
      "backOrderError": "Return order failed"
    },
    "invoice": {
      "table": {
        "invoiceNo": "invoiceNo",
        "orderNo": "orderNo",
        "companyAddress": "companyAddress",
        "companyName": "companyName",
        "creatorName": "creatorName"
      },
      "search": {
        "orderNoPlaceholder": "Associate the system order number",
        "placeholder": "Please enter",
        "keyWords": "keyWords"
      }
    }
  },
  "countryName": {
    "USA": "USA",
    "Canada": "Canada",
    "China": "China"
  },
  "menuType": {
    "menu": "menu",
    "btn": "Button",
    "unknown": "Unknown"
  },
  "roleType": {
    "normal": "normal",
    "customerService": "customerService",
    "finance": "finance",
    "director": "director"
  },
  "quoteHistory": {
    "searchPlaceholder": "Please enter the keywords (postal code/company name/city/state/waybill type) to search",
    "userNamePlaceholder": "Please enter your username"
  },
  "orderStatus": {
    "pending": "Pending",
    "quoting": "Quoting",
    "confirmed": "Confirmed",
    "prepared": "Prepared",
    "sentToCarrier": "Sent to Carrier",
    "dispatched": "Dispatched",
    "inTransit": "In Transit",
    "outForDelivery": "Out for Delivery",
    "delivered": "Delivered",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "unknown": "Unknown Status"
  },
  "auditStatus": {
    "awaiting": "awaiting",
    "passed": "passed",
    "denied": "denied"
  },
  "orderType": {
    "order": "order",
    "edit": "edit",
    "reduction": "reduction",
    "refund": "refund",
    "backOrder": "backOrder"
  },
  "role": {
    "bindUser": {
      "candidateList": "Alternative list",
      "placeholder": "Please enter the keywords",
      "selectedList": "Selected list"
    }
  }
}
